import axios from "../../../privateApi";

export const sendErrorReport = async (
  evoPathId: number,
  message: string,
  cantRememberPath: boolean,
) => {
  const res = await axios.post(
    `/evolved-players/${evoPathId}/send-error-report`,
    {
      message,
      cantRememberPath,
    },
  );
  return res.data;
};
